(function () {
    'use strict';

    angular.module('ib-others-fees-module')
        .service('OthersFeesViewModel', OthersFeesViewModel);

    OthersFeesViewModel.$inject = ['CurrencyService'];

    function OthersFeesViewModel (CurrencyService) {
        const self = this;
        self.getOthersViewModel = getOthersViewModel;
        self.getOtherInfo = getOtherInfo;
        self.deleteInfo = deleteInfo;
        self.updateInfo = updateInfo;
        return self;

        function getOthersViewModel (currency) {
            return {
                hasElements: false,
                others: [],
                total: {
                    total: 0,
                    totalFormatted: CurrencyService.formatPrice(currency, 0, true)
                }
            };
        }

        function getOtherInfo (otherFee, type, currency) {
            let other = {};
            switch (type) {
                    case 'DONATION':
                        other = createDonationFee(otherFee);
                        break;
                    case 'ONHOLD_IBERIA_PAY_AFOP':
                    case 'ONHOLD_CREDITCARD':
                    case 'ONHOLD_IBERIA_PAY':
                    case 'ONHOLD':
                        other = createCardOnHold(otherFee, currency);
                        break;
                    case 'SUMMARY_OTHER_FEES_ADMINISTRATION':
                        other = createAdminFee(otherFee, currency);
                        break;
                    case 'CARD':
                    default:
                        other = createCardFeed(otherFee);
                        break;
            }
            return other;
        }

        function createCardFeed (cardfee) {
            return {
                type: 'CARD',
                description: 'SUMMARY_OTHER_FEES_CREDIT_CARD',
                totalFormatted: cardfee.parsedFee || cardfee.totalPriceInfo,
                total: cardfee.totalFee || cardfee.total
            };
        }

        function createAdminFee (cardfee) {
            return {
                type: 'SUMMARY_OTHER_FEES_ADMINISTRATION',
                description: 'SUMMARY_OTHER_FEES_ADMINISTRATION',
                totalFormatted: cardfee.parsedFee || cardfee.totalPriceInfo,
                total: cardfee.totalFee || cardfee.total
            };
        }

        function createDonationFee (donationFee) {
            return {
                type: 'DONATION',
                description: donationFee.description,
                total: donationFee.total,
                totalFormatted: donationFee.totalFormatted
            };
        }

        function createCardOnHold (cardfee, currency) {
            const total = angular.isDefined(cardfee.total) ? cardfee.total : 0;

            return {
                type: 'ONHOLD',
                description: total === 0 ? 'PRICE_BREAKDOWN_ON_HOLD_24HRS' : 'PRICE_BREAKDOWN_ON_HOLD',
                totalFormatted: CurrencyService.formatPrice(currency, -Math.abs(total), true),
                total: -Math.abs(total)
            };
        }

        function deleteInfo (othersModel, otherType, currency) {
            if (otherType) {
                angular.forEach(othersModel.others, (fee, index) => {
                    if (fee.type === otherType || fee.description === otherType) {
                        othersModel.others.splice(index, 1);
                    }
                });
            } else {
                othersModel = getOthersViewModel(currency);
            }
        }

        function updateInfo (othersModel, currency) {
            let total = 0;
            angular.forEach(othersModel.others, (fee) => {
                total += fee.total;
            });
            othersModel.total = {
                total: total,
                totalFormatted: CurrencyService.formatPrice(currency, total, true)
            };
            othersModel.hasElements = othersModel.total.total >= 0 ||  othersModel.total.total < 0;

        }
    }


}

)();
